__turbopack_context__.v({
  "armBack": "Loader-module__OpcrDa__armBack",
  "armFront": "Loader-module__OpcrDa__armFront",
  "armPush": "Loader-module__OpcrDa__armPush",
  "armSwing": "Loader-module__OpcrDa__armSwing",
  "armSwingBack": "Loader-module__OpcrDa__armSwingBack",
  "body": "Loader-module__OpcrDa__body",
  "cart": "Loader-module__OpcrDa__cart",
  "cartBasket": "Loader-module__OpcrDa__cartBasket",
  "cartBob": "Loader-module__OpcrDa__cartBob",
  "cartHandle": "Loader-module__OpcrDa__cartHandle",
  "groundLine": "Loader-module__OpcrDa__groundLine",
  "head": "Loader-module__OpcrDa__head",
  "item": "Loader-module__OpcrDa__item",
  "item1": "Loader-module__OpcrDa__item1",
  "item2": "Loader-module__OpcrDa__item2",
  "item3": "Loader-module__OpcrDa__item3",
  "legBack": "Loader-module__OpcrDa__legBack",
  "legFront": "Loader-module__OpcrDa__legFront",
  "legSwingBack": "Loader-module__OpcrDa__legSwingBack",
  "legSwingFront": "Loader-module__OpcrDa__legSwingFront",
  "legWalk": "Loader-module__OpcrDa__legWalk",
  "overlay": "Loader-module__OpcrDa__overlay",
  "person": "Loader-module__OpcrDa__person",
  "pop": "Loader-module__OpcrDa__pop",
  "scene": "Loader-module__OpcrDa__scene",
  "spin": "Loader-module__OpcrDa__spin",
  "walk": "Loader-module__OpcrDa__walk",
  "walker": "Loader-module__OpcrDa__walker",
  "wheel": "Loader-module__OpcrDa__wheel",
  "wheelBack": "Loader-module__OpcrDa__wheelBack",
  "wheelFront": "Loader-module__OpcrDa__wheelFront",
});
